import { useLocation, useNavigate } from "react-router-dom";
import { useFeature } from "../../hooks/useFeature";
import { showToast } from "../ToastNotification";

interface NavbarProps {
    theme: string;
    isOpen: boolean;
}

interface NavItem {
    title: string;
    path: string;
    disabled: boolean;
    feature: boolean;
    message?: string;
}

const Navbar: React.FC<NavbarProps> = ({ theme, isOpen }) => {
    const location = useLocation();
    const navigate = useNavigate();
    const canReceiveRequest = useFeature("bedfinder:canReceiveRequest");
    const canSendRequest = useFeature("bedfinder:canSendRequest");
    const collaboratives = useFeature("bedfinder:collaboratives");
    const isActive = (path: string) => location.pathname === path;

    const navData: Record<string, NavItem[]> = {
        bedfinder: [
            { title: "Dashboard", path: "/bedfinder", disabled: false, feature: true },
            { title: "Requests We Received", path: "/bedfinder/beds-needed", disabled: false, feature: canReceiveRequest, message: "You don't have permission to receive requests. Please contact your administrator." },
            { title: "Requests We Sent", path: "/bedfinder/my-requests", disabled: false, feature: canSendRequest, message: "You don't have permission to create requests. Please contact your administrator." },
            { title: "Members", path: "/bedfinder/members", disabled: !collaboratives, feature: true },
            { title: "Settings", path: "/bedfinder/settings", disabled: false, feature: true }
        ],
        safeNight: [
            { title: "Home", path: "/safenight", disabled: false, feature: true },
            { title: "Alerts", path: "/safenight/needs", disabled: false, feature: true },
            { title: "Donations", path: "/safenight/donations", disabled: false, feature: true },
            { title: "Donors", path: "/safenight/donors", disabled: false, feature: true }
        ]
    };

    const navBarOnclickHandler = (path: string, feature: boolean, message?: string) => {
        feature
            ? navigate(path)
            : showToast(
                message ?? "You don't have permission. Please contact your administrator.", "error"
            );
    }

    return (
        <>

            <nav className={`${theme === "bedfinder" ? "bg-[#5EBCC2]" : "bg-[#719CBF]"}`}>
                <div className={`overflow-hidden transition-[max-height] duration-500 ease-in-out 
                    ${isOpen ? "max-h-96 opacity-100" : "max-h-0 opacity-0"} 
                    md:max-h-none md:opacity-100 md:flex md:justify-center`}>
                    <ul className="font-medium flex flex-col md:flex-row justify-center md:space-x-8 rtl:space-x-reverse rounded-lg">
                        {navData[theme].map((item: NavItem, index: number) => ( // ✅ Fix applied here
                            !item.disabled && (
                                <li key={index}>
                                    <button onClick={() => navBarOnclickHandler(item.path, item.feature ?? true, item.message)} className={`nav-link p-5 transition-colors duration-300 ease-in-out ${!item.feature ? "cursor-not-allowed" : ""} ${isActive(item.path) ? theme === "bedfinder" ? "bg-[#359AA0] hover:bg-[#359AA0]" : "bg-[#4F6D93] hover:bg-blue-400" : ""}`}>
                                        {item.title}
                                    </button>
                                </li>
                            )
                        ))}
                    </ul>
                </div>
            </nav>
        </>
    );
};

export default Navbar;
